<button mat-stroked-button color="primary" (click)="onSell()">Sell</button>
